import DetailCetakPermintaanBahanProduksi from './DetailCetakPermintaanBahanProduksi';

export default DetailCetakPermintaanBahanProduksi;
